<div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
  <h2 mat-dialog-title fxLayout="row" fxLayoutAlign="start center">
    Setup Phone Number for SMS
    <span fxFlex></span>
    <button mat-icon-button mat-dialog-close="">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content class="mat-typography" fxFlex>
    <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
      <mat-form-field appearance="outline" class="regular-form-field">
        <mat-label>Search Phone Number</mat-label>
        <mat-select formControlName="phoneNumber">
          <mat-select-trigger>
            <span class="selected-number-name" fxLayout="row" fxLayoutGap="5px">
              <span>{{phoneNumberControl.getRawValue()?.number | phoneNumber}}</span>
              <span>{{phoneNumberControl.getRawValue()?.alias}}</span>
            </span>
          </mat-select-trigger>
          <mat-form-field appearance="outline" class="regular-form-field no-label"
                          style="margin-left: 5px; margin-right: 5px; width: calc(100% - 10px);">
            <input matInput type="text" formControlName="phoneNumberFilter">
            <mat-icon matPrefix>search</mat-icon>
            <!--<button *ngIf="phoneNumberFilterControl.getRawValue()" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
              <mat-icon>close</mat-icon>
            </button>-->
          </mat-form-field>
          <mat-option *ngIf="(filteredPhoneNumbersList | async).length == 0">Empty</mat-option>
          <mat-option *ngFor="let option of filteredPhoneNumbersList | async" [value]="option" fxLayout="row"
                      fxLayoutGap="5px">
            <span>
              {{option.number | phoneNumber}}
            </span>
            <span>
              {{option.alias}}
            </span>
            <span>
              {{option.hasAssignedUsers ? '(has users assigned)' : ''}}
            </span>
          </mat-option>
        </mat-select>
        <mat-error>Phone number is required field</mat-error>
      </mat-form-field>

      <label class="label-text">
        Would you like to be notified of unread SMS messages when not logged in?
      </label>

      <div fxLayout="row wrap" fxLayoutAlign="start center">
        <app-mat-checkbox-input formControlName="receiveEmail" name="receiveEmail"
                                [submitted]="submitted"
                                label="Receive email alerts"
                                explanation="This user will receive emails to notify them of any new, unread SMS messages in their TeleGo Customer Portal. These emails will be sent if this user is not logged in, and if the message remains unread for 10 minutes."
        ></app-mat-checkbox-input>
        <app-mat-checkbox-input formControlName="includeText" name="includeText"
                                [submitted]="submitted"
                                label="View new messages in email"
                                explanation="This user will receive email notifications containing the actual text content of a new and unread SMS message. These emails will be sent if the user is not logged in, and if the message remains unread for 10 minutes."
        ></app-mat-checkbox-input>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button color="primary" mat-stroked-button cdkFocusInitial (click)="onSubmit()">Confirm</button>
    <button color="warn" mat-stroked-button mat-dialog-close="">Cancel</button>
  </mat-dialog-actions>
</div>
